import React from "react";
import { ArrowUpRight } from "lucide-react";
import { interestLinks } from "../mock";

export default function InterestLinks() {
  return (
    <section className="py-16 px-4 bg-gradient-to-b from-white to-blue-50/40">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="np-title inline-block text-2xl sm:text-3xl font-extrabold text-[#0e4a7a]">
            Te Puede Interesar
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto mt-4 text-sm sm:text-base">
            Métodos, herramientas y recursos para mejorar tus jugadas.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {interestLinks.map((l) => (
            <a
              key={l.title}
              href={l.href}
              className="np-card group bg-white rounded-2xl border border-blue-100 p-6 shadow-sm flex items-start justify-between gap-4"
            >
              <div>
                <h3 className="font-bold text-lg text-[#0e4a7a] group-hover:text-[#1d6cb1] transition-colors">
                  {l.title}
                </h3>
                <p className="text-sm text-gray-600 mt-1">{l.desc}</p>
              </div>
              <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center text-[#1d6cb1] group-hover:bg-[#1d6cb1] group-hover:text-white transition-all flex-shrink-0">
                <ArrowUpRight className="w-4 h-4" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
